import {
	API_ADMIN_GET_ALL_ANALYSESPACK,
	API_ADMIN_DELETE_ANALYSESPACK,
	API_ADMIN_GET_ANALYSESPACK,
	API_ADMIN_PATCH_ANALYSESPACK,
	ADMIN_INIT_NEW_ANALYSESPACK,
	ADMIN_RESET_FOCUS_ANALYSESPACK,
	API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS,
	API_GET_ANALYSESPACKS_DEPOSITS,
} from "../actions/analysesPack";
import { API_ADMIN_POST_ANALYSESPACK, API_GET_ALL_ANALYSESPACK } from "actions/analysesPack";

export function adminGetAnalysesPack(analysesPack) {
	return {
		type: API_ADMIN_GET_ANALYSESPACK,
		payload: {
			request: {
				url: `/admin/analysesPacks/${analysesPack.id}`,
			},
		},
	};
}

export function getAllAnalysesPack(isHome, folderId, prescriberId) {
	return {
		type: API_GET_ALL_ANALYSESPACK,
		payload: {
			request: {
				url: `/analysesPacks`,
				params: {
					home: isHome,
					folderId: folderId,
					prescriberId: prescriberId,
				},
			},
		},
	};
}

export function adminGetAllAnalysesPack() {
	return {
		type: API_ADMIN_GET_ALL_ANALYSESPACK,
		payload: {
			request: {
				url: `/admin/analysesPacks`,
			},
		},
	};
}

export function adminGetAnalysesPacksForCampaigns() {
	return {
		type: API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS,
		payload: {
			request: {
				url: `/admin/analysesPacks/campaigns`,
			},
		},
	};
}

export function getAnalysesPacksForDeposits() {
	return {
		type: API_GET_ANALYSESPACKS_DEPOSITS,
		payload: {
			request: {
				url: `/analysesPacks/deposits`,
			},
		},
	};
}

export function adminPostAnalysesPack(analysesPack) {
	return {
		type: API_ADMIN_POST_ANALYSESPACK,
		payload: {
			request: {
				url: `/admin/analysesPacks`,
				method: "POST",
				data: analysesPack,
			},
		},
	};
}

export function adminPatchAnalysesPack(analysesPack) {
	return {
		type: API_ADMIN_PATCH_ANALYSESPACK,
		payload: {
			request: {
				url: `/admin/analysesPacks/${analysesPack.id}`,
				method: "PATCH",
				data: analysesPack,
			},
		},
	};
}

export function adminDeleteAnalysesPack(analysesPack) {
	return {
		type: API_ADMIN_DELETE_ANALYSESPACK,
		payload: {
			request: {
				url: `/admin/analysesPacks/${analysesPack.id}`,
				method: "DELETE",
			},
		},
	};
}

export function initNewAnalysesPack() {
	return {
		type: ADMIN_INIT_NEW_ANALYSESPACK,
	};
}

export function resetFocusAnalysesPack() {
	return {
		type: ADMIN_RESET_FOCUS_ANALYSESPACK,
	};
}
